/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { extendTheme } from "@chakra-ui/react";
import { globalStyles } from "./styles";
import { breakpoints } from "./foundations/breakpoints";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { linkStyles } from "./components/link";
import { inputStyles } from "./components/input";
import { CardComponent } from "./additions/card/Card";
import { MainPanelComponent } from "./additions/layout/MainPanel";
import { PanelContentComponent } from "./additions/layout/PanelContent";
import { PanelContainerComponent } from "./additions/layout/PanelContainer";

// Chakra UI v2 theme configuration
export default extendTheme(
  { breakpoints }, // Breakpoints
  globalStyles,
  buttonStyles, // Button styles
  badgeStyles, // Badge styles
  linkStyles, // Link styles
  inputStyles, // Input styles
  CardComponent, // Card component
  MainPanelComponent, // Main Panel component
  PanelContentComponent, // Panel Content component
  PanelContainerComponent, // Panel Container component
  {
    // Font size scale - tüm yazı tipleri küçültüldü
    fontSizes: {
      xs: "10px",
      sm: "11px",
      md: "12px",
      lg: "13px",
      xl: "14px",
      "2xl": "15px",
      "3xl": "16px",
      "4xl": "17px",
      "5xl": "18px",
      "6xl": "19px",
      "7xl": "20px",
      "8xl": "21px",
      "9xl": "22px",
    },
    // Component font size ayarları
    components: {
      Text: {
        baseStyle: {
          fontSize: "12px",
        },
      },
      Heading: {
        baseStyle: {
          fontSize: "12px",
        },
        sizes: {
          xs: { fontSize: "11px" },
          sm: { fontSize: "12px" },
          md: { fontSize: "13px" },
          lg: { fontSize: "14px" },
          xl: { fontSize: "15px" },
          "2xl": { fontSize: "16px" },
          "3xl": { fontSize: "17px" },
          "4xl": { fontSize: "18px" },
        },
      },
      Select: {
        baseStyle: {
          field: {
            fontSize: "12px",
          },
        },
      },
      Input: {
        baseStyle: {
          field: {
            fontSize: "12px",
          },
        },
      },
      Textarea: {
        baseStyle: {
          fontSize: "12px",
        },
      },
      FormLabel: {
        baseStyle: {
          fontSize: "12px",
        },
      },
      Badge: {
        baseStyle: {
          fontSize: "12px",
        },
      },
      Link: {
        baseStyle: {
          fontSize: "12px",
        },
      },
      Table: {
        baseStyle: {
          th: {
            fontSize: "12px",
          },
          td: {
            fontSize: "12px",
          },
        },
      },
    },
    config: {
      initialColorMode: "light",
      useSystemColorMode: false,
      disableTransitionOnChange: false,
    },
  }
);
